module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "product-details-container"
  }, [_c('div', {
    staticClass: "product-details"
  }, [_c('div', {
    staticClass: "product-details__info"
  }, [_c('h1', {
    staticClass: "product-details__type-title"
  }, [_c('span', {
    staticClass: "product-details__type-title--left"
  }, [_vm._v(_vm._s(_vm.productDetails.proCategoryName))])]), _vm._v(" "), _c('div', {
    staticClass: "product-details__left"
  }, [_c('h2', {
    staticClass: "product-details__info-title"
  }, [_vm._v(_vm._s(_vm.productDetails.productName))]), _vm._v(" "), _c('h3', {
    staticClass: "product-details__info-title-eng"
  }, [_vm._v(_vm._s(_vm.companyInfo.fullEngName))]), _vm._v(" "), _c('div', {
    staticClass: "product-details__info-content"
  }, [_vm._v(_vm._s(_vm.productDetails.productInfo))])]), _vm._v(" "), _c('div', {
    staticClass: "product-details__right"
  }, [_c('div', {
    staticClass: "product-details__images",
    style: ({
      backgroundImage: ("url('" + _vm.imgSrcPrefix + (_vm.productDetails.productImg) + "')")
    })
  }, [_c('button', {
    on: {
      "click": _vm.beginApplyLoan
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.applyLoanBtn.text))])]), _vm._v(" "), _c('span', {
    staticClass: "product-details__button-desc"
  }, [_vm._v("APPLICATION")])])])]), _vm._v(" "), _c('div', {
    staticClass: "product-details__application-conditions"
  }, [_vm._m(0), _vm._v(" "), _c('h5', {
    staticClass: "product-details__title"
  }, [_vm._v("申请条件")]), _vm._v(" "), _c('h6', {
    staticClass: "product-details__title-eng"
  }, [_vm._v("APPLICATION CONDITIONS")]), _vm._v(" "), _c('div', {
    staticClass: "product-details__content other",
    domProps: {
      "innerHTML": _vm._s(_vm.fixHTMLLineSeparator(_vm.productDetails.applyConditions))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-details__application-people"
  }, [_vm._m(1), _vm._v(" "), _c('h5', {
    staticClass: "product-details__title"
  }, [_vm._v("适用人群")]), _vm._v(" "), _c('h6', {
    staticClass: "product-details__title-eng enother"
  }, [_vm._v("APPLICATION PEOPLE")]), _vm._v(" "), _c('div', {
    staticClass: "product-details__content",
    domProps: {
      "innerHTML": _vm._s(_vm.fixHTMLLineSeparator(_vm.productDetails.forPeople))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-details__materials-required"
  }, [_vm._m(2), _vm._v(" "), _c('h5', {
    staticClass: "product-details__title"
  }, [_vm._v("所需材料")]), _vm._v(" "), _c('h6', {
    staticClass: "product-details__title-eng other"
  }, [_vm._v("MATERIALS REQUIRED")]), _vm._v(" "), _c('div', {
    staticClass: "product-details__content",
    domProps: {
      "innerHTML": _vm._s(_vm.fixHTMLLineSeparator(_vm.productDetails.requiedFiles))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-details__suitable-city"
  }, [_vm._m(3), _vm._v(" "), _c('h5', {
    staticClass: "product-details__title"
  }, [_vm._v("适用城市")]), _vm._v(" "), _c('h6', {
    staticClass: "product-details__title-eng other"
  }, [_vm._v("SUITABLE CITY")]), _vm._v(" "), _c('div', {
    staticClass: "product-details__content",
    domProps: {
      "innerHTML": _vm._s(_vm.fixHTMLLineSeparator(_vm.productDetails.productCitys))
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "product-details__serial-number"
  }, [_c('span', [_vm._v("01")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "product-details__serial-number"
  }, [_c('span', [_vm._v("02")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "product-details__serial-number"
  }, [_c('span', [_vm._v("03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "product-details__serial-number"
  }, [_c('span', [_vm._v("04")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f01df6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDetails.vue
// module id = 1063
// module chunks = 1